import BasicBlock from '../components/BasicBlock';
import TypeIcon from '../TypeIcon';
import { CardHeader } from '../components/CardHeader';
import { initiatorTypes } from '../../constants';
import FieldsTable from '../FieldsTable';

const cardHeaderConfig = (t) => {
  return {
    [initiatorTypes['empty-initiator']]: {
      prefix: t('form submitted'),
      creationType: () => '',
    },
  };
};

const FormSubmittedEventBlock = ({ event, ...others }) => {
  return (
    <BasicBlock
      comments={event.comments}
      icon={
        <TypeIcon
          color="var(--color-viz-cat-10-primary)"
          icon="align-justify-light"
          size="16px"
        />
      }
      isDeletable={false}
      timestamp={event.created}
      title={
        <CardHeader
          event={event}
          name={event.data.formName}
          config={cardHeaderConfig}
        />
      }
      event={event}
      {...others}
    >
      <FieldsTable fields={event.data.fields} />
    </BasicBlock>
  );
};

export default FormSubmittedEventBlock;
